import React from 'react'
import { ThemeProvider } from 'styled-components'

import { LightTheme } from 'ui/bend'

import ThemeWrapper from './ThemeWrapper'
import Footer from 'components_v2/Footer'
import EntryProviders from 'components_v2/_entryPoints/EntryProviders'

/*
This component is used as a shim to load the new Footer in old non-redesigned pages
*/

const StyledFooter = ({ user, ...props }) => {
  return (
    <EntryProviders user={user}>
      <ThemeProvider theme={LightTheme}>
        <ThemeWrapper color='primary'>
          <Footer {...props} legacyPage={true} />
        </ThemeWrapper>
      </ThemeProvider>
    </EntryProviders>
  )
}

export default StyledFooter
